module.exports = __webpack_public_path__ + "img/ltkxprime-4x.dfa50e4.jpg";